module.exports = __webpack_public_path__ + "static/media/1.ff898da9.jpg";